<template>
    <div class="wrap">
        <div class="button_wrap flex-between">
            <div class="button_item left" @click="toNext(0)">
                <div class="text_wrap">
                    <div>期货交易</div>
                    <div>虚拟仿真实验</div>
                    <!-- <div>虚仿实验</div> -->
                </div>
                <div class="img_wrap"><img src="../../assets/img/left_up.png" alt="" /></div>
            </div>
            <div class="button_item right" @click="toNext(1)">
                <div class="text_wrap">
                    <div>期权交易</div>
                    <div>虚拟仿真实验</div>
                    <!-- <div>虚仿实验</div> -->
                </div>
                <div class="img_wrap"><img src="../../assets/img/right_up.png" alt="" /></div>
            </div>
        </div>
        <div class="notice">
            <div>注：</div>
            <div>
                <div>
                    2019年，期货交易虚拟仿真实验被认定为省级虚拟仿真实验项目，2021年被进一步认定为四川省一流课程，2022年上线国家高等教育智慧教育平台；2022年，期权交易虚拟仿真实验被认定为四川省一流课程。
                </div>
            </div>
        </div>
        <el-dialog
            :visible.sync="changeVisible"
            width="30%"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            :show-close="false"
            center
            title="更改密码"
        >
            <el-form label-width="80px" :model="regForm" :rules="regRules">
                <el-form-item prop="password" label="新密码">
                    <el-input type="password" v-model="regForm.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item prop="rePassword" label="确认密码">
                    <el-input type="password" v-model="regForm.rePassword" placeholder="请再次输入密码"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" center class="dialog-footer">
                <el-button type="primary" @click="setPassword">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'project',
    data() {
        return {
            changeVisible: false,
            regForm: {
                password: '',
                rePassword: ''
            },
            regRules: {
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8位数以上的密码', trigger: 'blur' }
                ],
                rePassword: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入6位数以上的密码', trigger: 'blur' }
                ]
            }
        };
    },
    mounted() {
        this.showChangePass();
    },
    methods: {
        setPassword() {
            if (this.regForm.password !== this.regForm.rePassword) {
                return this.$message.warning('两次输入的密码不一致，请重新输入');
            } else {
                this.$post(this.api.resetUserPwd, { password: this.regForm.password })
                    .then((res) => {
                        this.changeVisible = false;
                        return this.$message.success('更改成功');
                    })
                    .catch((err) => {
                        return this.$message.error(err.errmessage);
                    });
            }
        },
        showChangePass() {
            if (this.$store.state.isExpertLogin) {
                return;
            }
            this.$get(this.api.isRequiredReset)
                .then((res) => {
                    if (this.$store.state.userName.includes('专家')) {
                    } else {
                        if (res.message) this.changeVisible = true;
                    }
                })
                .catch((err) => {});
        },
        toFuture() {
            this.core.toSubSystem('', '', '', 0);
        },
        toNext(val) {
            this.$router.push(`ProjectIntro?isFuture=${val}`);
        }
    }
};
</script>
<style lang="scss" scoped>
.wrap {
    width: 100%;
    height: 100%;
    position: fixed;
    background: url('../../assets/img/indexBg.jpg');
    background-size: 100%;
    box-sizing: border-box;
    padding: 0px 180px;

    .button_wrap {
        width: 600px;
        margin: 37vh auto 0 auto;

        .button_item {
            height: 100px;
            margin-bottom: 230px;

            .text_wrap {
                div {
                    width: 280px;
                    text-align: center;
                    font-size: 40px;
                    font-weight: bold;
                    margin: 20px 0px;
                    letter-spacing: 2px;
                }

                margin-bottom: 30px;
            }

            .img_wrap {
                text-align: center;
            }
        }

        .button_item:hover {
            opacity: 0.7;
            cursor: pointer;
        }

        .left {
            color: #ff5288;
        }

        .right {
            color: #3677ed;
        }
    }

    .notice {
        // width: 900px;
        display: flex;
        color: #7aa0b7;
        font-size: 24px;
        letter-spacing: 4px;
        line-height: 1.5;
    }
}
</style>
